import { FC } from 'react';
import { AspectRatio, Box, Container, Heading } from '@chakra-ui/react';
import Image from './Image';
import HtmlContent from './HtmlContent';
import { HeroProps, MhyChakraProps } from '../types';

const HeroCentered: FC<HeroProps & Omit<MhyChakraProps, 'variant'>> = ({
  heading,
  wysiwyg,
  image,
  children,
  ...restChakraProps
}) => (
  <Box {...restChakraProps} mt={[-8, -10, -14]}>
    {image && (
      <Container maxW="container.xl" variant="main" mb={0}>
        <Box mb={6}>
          <AspectRatio
            ratio={[375 / 447, 375 / 447, 1440 / 600]}
            maxH={[null, null, null, '60vh']}
            minH={[null, null, null, '407px']}
            sx={{ '&::before': { pointerEvents: 'none' } }}
          >
            <Image
              src={image?.src}
              alt={heading.title}
              layout="fill"
              objectFit="contain"
              priority
              noRounding
            />
          </AspectRatio>
        </Box>
      </Container>
    )}
    <Container maxW="container.md" variant="main" mb={0}>
      <Heading as="h1" variant="h3" textAlign="center" mb={6}>
        {heading.title}
      </Heading>
      {wysiwyg && (
        <HtmlContent
          sx={{ 'p:last-of-type': { mb: 0 } }}
          textAlign="center"
          html={wysiwyg}
        />
      )}
    </Container>
  </Box>
);

export default HeroCentered;
